import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type CostContentProps = {
  configData: ConstraintConfigType;
};

export function CostContent({ configData }: CostContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="cost"
    />
  );
}
